// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Pw0yiyImjs9_G632BseY {
  border: 1px solid #ddd;
  padding: 5px 10px;
  display: inline-block;
  width: 100px;
}
.bDxL1SwVGmNTNZdSzuPJ {
  color: red;
  width: 210px;
}
.Ot4S5RU_WPoZC6KB3Wd4 {
  padding: 5px;
  border: 1px solid #ddd;
}
.PwYShwcASXk9EJen1vkU {
  padding: 5px 10px;
  border-bottom: 1px solid #ddd;
}
.YLjTNDOoYBq8XzIwgCBe {
  padding: 10px 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/Composition/styles.module.less"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,iBAAA;EACA,qBAAA;EACA,YAAA;AACF;AAEA;EACE,UAAA;EACA,YAAA;AAAF;AAGA;EACE,YAAA;EACA,sBAAA;AADF;AAIA;EACE,iBAAA;EACA,6BAAA;AAFF;AAKA;EACE,eAAA;AAHF","sourcesContent":[".totalFraction {\n  border: 1px solid #ddd;\n  padding: 5px 10px;\n  display: inline-block;\n  width: 100px;\n}\n\n.errorStatus {\n  color: red;\n  width: 210px;\n}\n\n.warpContainer {\n  padding: 5px;\n  border: 1px solid #ddd;\n}\n\n.header {\n  padding: 5px 10px;\n  border-bottom: 1px solid #ddd;\n}\n\n.warpBody {\n  padding: 10px 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"totalFraction": `Pw0yiyImjs9_G632BseY`,
	"errorStatus": `bDxL1SwVGmNTNZdSzuPJ`,
	"warpContainer": `Ot4S5RU_WPoZC6KB3Wd4`,
	"header": `PwYShwcASXk9EJen1vkU`,
	"warpBody": `YLjTNDOoYBq8XzIwgCBe`
};
export default ___CSS_LOADER_EXPORT___;
